/*
 * Purpose: LEGACY ONLY — /builder?panel= redirects; do not use in new code (P6)
 * Last modified: 2026-06-28 | Agent
 * Completeness: 100
 */
import type { BuilderPanelId } from '@/lib/productActivities';
import { APP_ROUTES, withFlowQuery } from '@/lib/appRoutes';

/** @internal Legacy redirect target for /builder?panel=… */
export function builderPanelToPath(panel: BuilderPanelId, flowId?: string | null): string {
  switch (panel) {
    case 'flows':
      return withFlowQuery(APP_ROUTES.flows, flowId);
    case 'templates':
      return withFlowQuery(APP_ROUTES.flowTemplates, flowId);
    case 'builder':
      return withFlowQuery(APP_ROUTES.missionMap, flowId);
    case 'secrets':
      return APP_ROUTES.connectSecrets;
    case 'connections':
      return APP_ROUTES.connectLibrary;
    case 'integrations':
      return APP_ROUTES.connectIntegrations;
    case 'scheduler':
      return withFlowQuery(APP_ROUTES.missionOperateScheduler, flowId);
    case 'monitor':
      return withFlowQuery(APP_ROUTES.missionOperateMonitor, flowId);
    case 'debug':
      return withFlowQuery(APP_ROUTES.missionOperateDebug, flowId);
    case 'analytics':
      return withFlowQuery(APP_ROUTES.missionInsightsAnalytics, flowId);
    case 'logs':
      return withFlowQuery(APP_ROUTES.missionInsightsLogs, flowId);
    case 'activity':
      return withFlowQuery(APP_ROUTES.missionInsightsActivity, flowId);
    case 'stats':
      return withFlowQuery(APP_ROUTES.missionInsightsStats, flowId);
    case 'settings':
      return withFlowQuery(APP_ROUTES.missionSettingsFlow, flowId);
    case 'versions':
      return withFlowQuery(APP_ROUTES.missionSettingsVersions, flowId);
    case 'collaborate':
      return withFlowQuery(APP_ROUTES.missionSettingsShare, flowId);
    default:
      return withFlowQuery(APP_ROUTES.missionMap, flowId);
  }
}

export function resolveBuilderLegacyRedirect(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const panel = params.get('panel') as BuilderPanelId | null;
  const flowId = params.get('flow');
  if (!panel) return withFlowQuery(APP_ROUTES.missionMap, flowId);
  return builderPanelToPath(panel, flowId);
}
